module.exports = __webpack_public_path__ + "img/card_replacement.d9a0de79.svg";